var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_24431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.65772 26.4816C1.65649 30.9519 2.82454 35.3168 5.04557 39.1641L1.44531 52.3093L14.8977 48.782C18.6185 50.8076 22.7873 51.8689 27.0237 51.8692H27.0348C41.0199 51.8692 52.404 40.4891 52.41 26.5016C52.4127 19.7236 49.7755 13.3501 44.9841 8.55497C40.1935 3.76026 33.8222 1.11833 27.0338 1.11523C13.0471 1.11523 1.6637 12.4947 1.65793 26.4816",
    fill: "url(#paint0_linear_795_24431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.751909 26.4735C0.750466 31.1046 1.96038 35.6257 4.2606 39.6108L0.53125 53.2271L14.466 49.5734C18.3055 51.6668 22.6283 52.7705 27.0271 52.7722H27.0384C41.5252 52.7722 53.3184 40.9828 53.3245 26.4945C53.327 19.473 50.595 12.8703 45.6324 7.90344C40.6692 2.93716 34.07 0.200153 27.0384 0.197266C12.5491 0.197266 0.757684 11.985 0.751909 26.4735ZM9.05036 38.9244L8.53005 38.0985C6.34284 34.6208 5.1884 30.6019 5.19005 26.4751C5.1948 14.4327 14.9954 4.6352 27.0467 4.6352C32.8828 4.63768 38.3675 6.91274 42.4928 11.0405C46.6179 15.1687 48.8878 20.6563 48.8864 26.4929C48.881 38.5353 39.0803 48.334 27.0384 48.334H27.0298C23.1088 48.332 19.2634 47.279 15.9098 45.2891L15.1117 44.8158L6.84252 46.9839L9.05036 38.9242V38.9244Z",
    fill: "url(#paint1_linear_795_24431)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4743 15.49C19.9823 14.3964 19.4644 14.3743 18.9965 14.3551C18.6134 14.3386 18.1753 14.3399 17.7377 14.3399C17.2997 14.3399 16.588 14.5046 15.9865 15.1615C15.3843 15.8189 13.6875 17.4077 13.6875 20.639C13.6875 23.8705 16.0411 26.9933 16.3692 27.432C16.6977 27.8698 20.913 34.7131 27.5888 37.3458C33.1371 39.5336 34.2662 39.0985 35.4703 38.9888C36.6747 38.8795 39.3564 37.4004 39.9035 35.8667C40.451 34.3333 40.451 33.0188 40.2869 32.7441C40.1227 32.4704 39.6847 32.3061 39.0279 31.9778C38.3708 31.6493 35.1418 30.0603 34.5398 29.8411C33.9376 29.6221 33.4998 29.5128 33.0618 30.1704C32.6238 30.827 31.366 32.3061 30.9827 32.7441C30.5997 33.1832 30.2163 33.2378 29.5597 32.9093C28.9025 32.5797 26.7872 31.887 24.2777 29.6497C22.3252 27.9088 21.007 25.7589 20.6238 25.1012C20.2407 24.4446 20.5828 24.0887 20.9121 23.7614C21.2072 23.4671 21.5692 22.9945 21.8979 22.6111C22.2254 22.2275 22.3347 21.9539 22.5537 21.5158C22.7729 21.0774 22.6632 20.6938 22.4992 20.3653C22.3347 20.0368 21.0584 16.7886 20.4743 15.49Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_795_24431",
    x1: 2549.68,
    y1: 5120.52,
    x2: 2549.68,
    y2: 1.11523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_795_24431",
    x1: 2640.2,
    y1: 5303.18,
    x2: 2640.2,
    y2: 0.197266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_24431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.7933,
    height: 53.2057,
    fill: "white",
    transform: "translate(0.53125 0.197266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.4bd12b12eedc933ffb2678f89210d500.svg";
export { ForwardRef as ReactComponent };